<div
  class="offcanvas offCanvasEnd offcanvas-end"
  tabindex="-1"
  id="identifyFeature"
  aria-labelledby="identifyFeature"
>
  <div class="offcanvas-header">
    <div class="w-100">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="m-0">Identify Feature</h2>
        <button
          type="button"
          class="btn btn-secondary btn-icon-only"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="offcanvas-body">
    <div class="overflow-hidden w-100" id="identifyScrollContainerTop">
      <div *ngFor="let layer of featuresInfo">
        <strong
          class="text-break d-block layer-heading mt-3"
          [innerHTML]="layer.layerName"
        ></strong>
        <ng-template ngFor let-attribute [ngForOf]="layer.properties">
          <!--exclude geometry and internal attributes-->
          <dl class="border-bottom mb-0 py-1" *ngIf="attribute.property !== 'geometry' && !attribute.property.match('ome_.*')">
            <dt class="text-break mb-0" [innerHTML]="attribute.property"></dt>
            <dd class="text-break mb-0" [innerHTML]="attribute.value"></dd>
          </dl>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between p-3">
    <app-back-to-top target="identifyScrollContainerTop"></app-back-to-top>
  </div>
</div>
